export default __webpack_public_path__ + "pgnv-assets/c4716f12775f660d82404d9f3cbd0dce.png";